<div (click)="toggleCheck()"> 
    <div *ngIf="checked" class="chunky-checkbox blue">
        <span class="check-mark">&#10003;</span>
    </div>
    <div *ngIf="!checked" class="chunky-checkbox gray"></div>
</div>